module.exports = __webpack_public_path__ + "media/images/logo-full-white-3fa9b901bf582346084f3d162f1ad402.svg";